"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaylistController = void 0;

var _VideoController = require("./VideoController");

var _getProperty = require("../../../util/getProperty");

var _TimeRange = require("../../../util/TimeRange");

var _Time = require("../../../util/Time");

var _ensureAllSourcesHaveItems = require("../ensureAllSourcesHaveItems");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ControllerID = 90;

var PlaylistController = /*#__PURE__*/function () {
  function PlaylistController() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PlaylistController);

    this._initialItemId = opts.initialId ? opts.initialId : null;
    this._currentIndex = 0;
    this._items = [];
    this.id = opts.id || ControllerID++;
    this.fluid = true;
    this._fluidSources = [];
    this._fluidSource = null;
    this._lastVideoTimeUpdate = -1;
    this._waitingForFluidSourceUpdate = null;
    this._waitingToJumpTo = null;
    this._waitingToJumpToLocal = null;
    this._gotoDebounce = null;
    this._lastInsideMoment = false;
    this.touches = null; // cache items

    this._sortedItems = null;
    this._firstActiveFluidSource = null;
    this._lastActiveFluidSource = null;
    this._activeFluidSources = null;
    this._mainFluidSources = null;
    this._sortedVisibleItems = null; // from VideoPlayer

    this._cameras = []; // array of cameras

    this._defaultCamera = "tracecam"; // default camera

    this._camera = "tracecam"; // active camera

    this.onItemChanged = opts.onItemChanged ? opts.onItemChanged : null;
  }

  _createClass(PlaylistController, [{
    key: "destroy",
    value: function destroy() {
      console.log("PlaylistController.destroy", this.id);

      if (this._videoController) {
        this.videoController.destroy();
        this._videoController._playlistController = null;
        this._videoController = null;
      }

      var index = PlaylistController._instances.indexOf(this);

      if (index) {
        PlaylistController._instances.splice(index, 1);
      }
    }
  }, {
    key: "currentIndex",
    get: function get() {
      return this._currentIndex;
    },
    set: function set(val) {
      if ( // eslint-disable-next-line eqeqeq
      val != null && val >= 0 && val < this.items.length && val !== this._currentIndex) {
        this._lastIndex = this._currentIndex;
        this._currentIndex = val;
      }
    }
  }, {
    key: "cameras",
    get: function get() {
      return this._cameras;
    },
    set: function set(val) {
      var valNames = val.map(function (item) {
        return item.name + item.game_clip_id;
      }).join("#"); // get names of cameras

      var camNames = this._cameras.map(function (item) {
        return item.game_clip_id;
      }).join("#"); // get names of cameras


      if (valNames !== camNames) {
        console.log("PlaylistController.setCameras", val);
        this._cameras = val; // this.updateFluidSource()
      }
    }
  }, {
    key: "defaultCamera",
    get: function get() {
      return this._defaultCamera;
    },
    set: function set(val) {
      this._defaultCamera = val;
    }
  }, {
    key: "camera",
    get: function get() {
      return this._camera;
    },
    set: function set(val) {
      // eslint-disable-next-line eqeqeq
      if (val != null && this._camera !== val) {
        console.log("PlaylistController: set camera", val);
        this._camera = val;
        this.resetCache();
        this.notify();
      }
    }
  }, {
    key: "items",
    get: function get() {
      if (!this._items) {
        this._items = [];
      }

      return this._items;
    },
    set: function set(val) {
      // eslint-disable-next-line eqeqeq
      if (val != null && Array.isArray(val)) {
        this._items = val;

        if (this._initialItemId) {
          this._initialItemId = null;
        } else {
          this._currentIndex = 0;
        }
      }
    }
  }, {
    key: "fullGameMoments",
    get: function get() {
      if (!this._fullGameMoments) {
        this._fullGameMoments = [];
      }

      return this._fullGameMoments;
    },
    set: function set(val) {
      // eslint-disable-next-line eqeqeq
      if (val != null && Array.isArray(val)) {
        this._fullGameMoments = val;
      }
    }
  }, {
    key: "nextItem",
    get: function get() {
      var item = null;
      var index = this.currentIndex + 1;

      if (index >= this.items.length) {
        index = 0;
      }

      if (index < 0) {
        index = 0;
      }

      if (0 <= index && index < this.items.length) {
        item = this.items[index];
      }

      return item;
    }
  }, {
    key: "nextMoment",
    get: function get() {
      var item = this.nextItem;
      return item && item.moment ? item.moment : item;
    }
  }, {
    key: "prevItem",
    get: function get() {
      var item = null;
      var index = this.currentIndex - 1;

      if (index < 0) {
        index = this.items.length - 1;
      }

      if (index >= this.items.length) {
        index = this.items.length - 1;
      }

      if (0 <= index && index < this.items.length) {
        item = this.items[index];
      }

      return item;
    }
  }, {
    key: "prevMoment",
    get: function get() {
      var item = this.prevItem;
      return item && item.moment ? item.moment : item;
    }
  }, {
    key: "currentItem",
    get: function get() {
      var item = null;

      if (this.currentIndex >= 0 && this.items.length > this.currentIndex) {
        item = this.items[this.currentIndex];
      }

      return item;
    }
  }, {
    key: "currentMoment",
    get: function get() {
      var item = this.currentItem;
      return item && item.moment ? item.moment : item;
    }
  }, {
    key: "insideMoment",
    get: function get() {
      var val = false;

      if (this.fluid) {
        if (this._videoController.controllingSource) {
          if (this.currentItem && this.currentItem.hidden) {
            val = false;
          } else {
            var time = this.fluidCurrentTime(this._videoController.controllingSource.video.currentTime, this._videoController.controllingSource.moment);

            var gameTime = _Time.Time.fromSeconds(time, this.firstMainFluidSource().start_time);

            var momentRange = _TimeRange.TimeRange.fromMoment(this.currentMoment);

            momentRange.fuzz = 500;
            val = momentRange.contains(gameTime);
          }
        }

        if (val !== this._lastInsideMoment) {
          this._lastInsideMoment = val;
          this.notify();
        }
      } else {
        val = true;
      }

      return val;
    } // set the fluid sources

  }, {
    key: "fluidSources",
    get: function get() {
      if (this._fluidSource === null || this._fluidSources === undefined) {
        return [];
      }

      return this._fluidSources;
    } // get the current fluid source

  }, {
    key: "fluidSource",
    get: function get() {
      return this._fluidSource;
    }
  }, {
    key: "setItems",
    value: function setItems(items) {
      var initialId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var change = false;
      this.fluid = false;
      console.log("PlaylistController.setItems NOT FLUID", items, initialId);
      this._videoController.fluid = false;

      if (JSON.stringify(items) !== JSON.stringify(this.items)) {
        console.log("PlaylistController.setItems: items changed", this.items, items);
        this.items = items;
        change = true;
      }

      if (change) {
        this.resetCache();
        console.log("PlaylistController.setItems: change", this.items);
        this._waitingForNonFluidSourceUpdate = true;

        if (initialId) {
          this._initialItemId = initialId;
          var item = this.items.find(function (item) {
            return item.game_clip_id === initialId || item.user_playlist_clip_id === initialId;
          });
          this._currentIndex = this.items.indexOf(item);
        } else {
          this._currentIndex = 0;
        }

        this.notify();
      }
    }
  }, {
    key: "setSourcesAndItems",
    value: function setSourcesAndItems(sources, origItems) {
      var initialId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var camera = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "tracecam";
      var startAt = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      this.fluid = true;
      this._videoController.fluid = true;
      var items = (0, _ensureAllSourcesHaveItems.ensureAllSourcesHaveItems)(sources, origItems);
      var change = false;

      if (initialId !== this._initialItemId) {
        console.log("PlaylistController.setSourcesAndItems: initialId changed", initialId, this._initialItemId);
        this._initialItemId = initialId;
      }

      if (JSON.stringify(sources) !== JSON.stringify(this._fluidSources)) {
        console.log("PlaylistController.setSourcesAndItems: sources changed");
        this._fluidSources = sources.sort(function (a, b) {
          return a.start_time - b.start_time;
        });
        change = true;
      }

      if (JSON.stringify(items) !== JSON.stringify(this.items)) {
        console.log("PlaylistController.setSourcesAndItems: items changed");
        this.items = items;
        change = true;
      }

      if (change) {
        console.log("PlaylistController.setSourcesAndItems: camera", camera);
        console.log("PlaylistController.setSourcesAndItems: change");
        this.resetCache();
        this.updateFluidSource();
        this.defaultCamera = camera;
        this.camera = camera;
        this._videoController.defaultCamera = camera;

        if (initialId) {
          if (startAt) {
            this._waitingToJumpTo = startAt;
          } else {
            this.goToItem(initialId, true);
          }
        } else {
          this.notify();
        }
      }

      return change;
    }
  }, {
    key: "resetCache",
    value: function resetCache() {
      this._sortedItems = null;
      this._sortedVisibleItems = null;
      this._firstActiveFluidSource = null;
      this._lastActiveFluidSource = null;
      this._activeFluidSources = null;
      this._mainFluidSources = null;
      this._firstMainFluidSource = null;
      this._lastMainFluidSource = null;
    }
  }, {
    key: "sortedItems",
    value: function sortedItems() {
      if (!this._sortedItems) {
        this._sortedItems = this.items.sort(function (a, b) {
          return a.start_time - b.start_time;
        });
      }

      return this._sortedItems;
    }
  }, {
    key: "sortedVisibleItems",
    value: function sortedVisibleItems() {
      if (!this._sortedVisibleItems) {
        this._sortedVisibleItems = _toConsumableArray(this.sortedItems());
        this._sortedVisibleItems = this._sortedVisibleItems.filter(function (item) {
          return !item.hidden;
        });
      }

      return this._sortedVisibleItems;
    }
  }, {
    key: "mainFluidSources",
    value: function mainFluidSources() {
      if (!this._mainFluidSources) {
        this._mainFluidSources = this.fluidSources.filter(function (source) {
          return "tracecam" === (0, _getProperty.getProperty)("meta.camera.name", source, "");
        });
      }

      return this._mainFluidSources;
    }
  }, {
    key: "firstMainFluidSource",
    value: function firstMainFluidSource() {
      if (!this._firstMainFluidSource) {
        var first = null;

        var _iterator = _createForOfIteratorHelper(this.mainFluidSources()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var source = _step.value;

            if (first === null || source.start_time < first.start_time) {
              first = source;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this._firstMainFluidSource = first;
      }

      return this._firstMainFluidSource;
    }
  }, {
    key: "lastMainFluidSource",
    value: function lastMainFluidSource() {
      if (!this._lastMainFluidSource) {
        var last = null;

        var _iterator2 = _createForOfIteratorHelper(this.mainFluidSources()),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var source = _step2.value;

            if (last === null || source.start_time > last.start_time) {
              last = source;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this._lastMainFluidSource = last;
      }

      return this._lastMainFluidSource;
    }
  }, {
    key: "activeFluidSources",
    value: function activeFluidSources() {
      var _this = this;

      if (!this._activeFluidSources) {
        console.log("PlaylistController.activeFluidSources camera", this._camera);
        var sources = [];

        var _iterator3 = _createForOfIteratorHelper(this.fluidSources),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var main = _step3.value;
            sources.push(main);

            if (main.sources) {
              var _iterator4 = _createForOfIteratorHelper(main.sources),
                  _step4;

              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var source = _step4.value;
                  sources.push(source);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        this._activeFluidSources = sources.filter(function (source) {
          return _this.camera === (0, _getProperty.getProperty)("meta.camera.name", source, "");
        });
      }

      return this._activeFluidSources;
    }
  }, {
    key: "activeFluidSource",
    value: function activeFluidSource() {
      var _this$_videoControlle, _this$_videoControlle2;

      var val = (_this$_videoControlle = this._videoController) === null || _this$_videoControlle === void 0 ? void 0 : (_this$_videoControlle2 = _this$_videoControlle.controllingSource) === null || _this$_videoControlle2 === void 0 ? void 0 : _this$_videoControlle2.moment;

      if (!val) {
        val = this._fluidSource;
      }

      return val;
    }
  }, {
    key: "firstActiveFluidSource",
    value: function firstActiveFluidSource() {
      if (!this._firstActiveFluidSource) {
        var first = null;

        var _iterator5 = _createForOfIteratorHelper(this.activeFluidSources()),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var source = _step5.value;

            if (first === null || source.start_time < first.start_time) {
              first = source;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        this._firstActiveFluidSource = first;
      }

      return this._firstActiveFluidSource;
    }
  }, {
    key: "lastActiveFluidSource",
    value: function lastActiveFluidSource() {
      if (!this._lastActiveFluidSource) {
        var last = null;

        var _iterator6 = _createForOfIteratorHelper(this.activeFluidSources()),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var source = _step6.value;

            if (last === null || last.start_time < source.start_time) {
              last = source;
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        this._lastActiveFluidSource = last;
      }

      return this._lastActiveFluidSource;
    } // the time (game start epoch 0) of the play head in seconds

  }, {
    key: "fluidCurrentTime",
    value: function fluidCurrentTime(t, m) {
      var ct = 0;
      var firstSource = this.firstMainFluidSource();

      if (firstSource && m) {
        var firstStart = _Time.Time.fromMoment(firstSource);

        if (this._waitingToJumpTo) {
          return this._waitingToJumpTo;
        }

        if (this._waitingForFluidSourceUpdate || this._videoController.initialLoading) {
          var momentStart = _Time.Time.fromMoment(this.currentMoment);

          return momentStart.utcSeconds - firstStart.utcSeconds;
        }

        var mStart = _Time.Time.fromMoment(m);

        mStart.subtractMilliseconds(firstStart.utc);
        mStart.addSeconds(t);
        ct = mStart.utcSeconds;
      }

      return ct;
    }
    /**
     * returns the utc start time in seconds of where we should start
     * loading fluid video.
     *
     * This method is key to opening deep links to a specific camera
     *
     * @return {number} utc start time in seconds
     * @memberof PlaylistController
     */

  }, {
    key: "fluidStartUTC",
    value: function fluidStartUTC() {
      var firstRawVideo = this.firstMainFluidSource();

      var firstStart = _Time.Time.fromMoment(firstRawVideo);

      var momentStart = _Time.Time.fromMoment(this.currentMoment);

      var fluidStart = momentStart.utcSeconds; // override fluid start if we are waiting to jump to a time

      if (this._waitingToJumpTo) {
        fluidStart = firstStart.utcSeconds + this._waitingToJumpTo;
      }

      console.log("PlaylistController.fluidStartUTC", fluidStart, firstStart.utcSeconds);
      return fluidStart;
    } // called by video controller
    // to get moment start in video time seconds

  }, {
    key: "fluidStart",
    value: function fluidStart() {
      var firstRawVideo = this.firstMainFluidSource();

      var firstStart = _Time.Time.fromMoment(firstRawVideo);

      var fluidSourceStart = _Time.Time.fromMoment(this.activeFluidSource());

      var momentStart = _Time.Time.fromMoment(this.currentMoment);

      var fluidStart = null;

      if (this.activeFluidSource() && this.currentMoment) {
        fluidStart = momentStart.utcSeconds - fluidSourceStart.utcSeconds;
        fluidStart = Math.round(fluidStart * 100) / 100;
      } // override fluid start if we are waiting to jump to a time


      if (this._waitingToJumpTo) {
        fluidStart = this._waitingToJumpTo - (fluidSourceStart.utcSeconds - firstStart.utcSeconds);
      } // just log


      if (this._lastFluidStart !== fluidStart) {
        this._lastFluidStart = fluidStart;
        console.log("PlaylistController.fluidStart", fluidStart, this.activeFluidSource());
      }

      return fluidStart;
    } // called by video controller
    // to get moment end in seconds video time

  }, {
    key: "fluidStop",
    value: function fluidStop() {
      var fluidStop = null;

      if (this._fluidSource && this.currentMoment) {
        fluidStop = this.fluidStart() + this.currentMoment.duration;
      }

      if (this._waitingToJumpTo) {
        return Number.MAX_SAFE_INTEGER;
      }

      return fluidStop;
    }
  }, {
    key: "fluidDuration",
    value: function fluidDuration() {
      var firstRawVideo = this.firstMainFluidSource();
      var lastRawVideo = this.lastMainFluidSource();

      if (lastRawVideo && firstRawVideo) {
        var range = _TimeRange.TimeRange.fromUTC(firstRawVideo.start_time, lastRawVideo.start_time + lastRawVideo.duration * 1000);

        return range.durationSeconds;
      } else {
        return 90 * 60;
      }
    } // time updates from video controller, videoTime is in seconds, epoch is video time

  }, {
    key: "onVideoTimeUpdate",
    value: function onVideoTimeUpdate(currentVideoTime) {
      // abort if we are not fluid
      if (!this.fluid) {
        return;
      } // abort if we are waiting for a fluid source update


      if (this._waitingForFluidSourceUpdate) {
        console.log("PlaylistController.onVideoTimeUpdate: waiting for fluid source update");
        return;
      } // abort if video player is doing initial load


      if (this._videoController.initialLoading) {
        console.log("PlaylistController.onVideoTimeUpdate: initial loading");
        return;
      } // if not doing initial load reset _waitingToJump
      else {
        this._waitingToJumpTo = null;
      } // abort if we are waiting to jump


      if (this._waitingToJumpTo) {
        return;
      } // trigger inside moment getter to notify if needed
      // eslint-disable-next-line no-unused-vars


      var inside = this.insideMoment; // convert the game time

      var firstStart = _Time.Time.fromMoment(this.firstMainFluidSource());

      var gameTime = _Time.Time.fromSeconds(currentVideoTime, (0, _getProperty.getProperty)("_videoController.controllingSource.moment.start_time", this, 0));

      if (this._waitingToJumpToLocal) {
        var diff = gameTime.utcSeconds - firstStart.utcSeconds;
        console.log("PlaylistController.onVideoTimeUpdate: waiting to jump local", diff, this._waitingToJumpToLocal);

        if (Math.abs(diff - this._waitingToJumpToLocal) < 2) {
          console.log("PlaylistController.onVideoTimeUpdate: jump to local complete");
          this._waitingToJumpToLocal = null;
        }
      }

      var timeKey = Math.round(gameTime.utcSeconds * 10); //ten times per second

      if (timeKey !== this._lastVideoTimeUpdate) {
        this._lastVideoTimeUpdate = timeKey;
        var bestItem = this.itemForTime(gameTime.utcSeconds - firstStart.utcSeconds);

        if (bestItem === this.currentItem) {
          return;
        } else {
          // choose the first item
          console.log("PlaylistController.onVideoTimeUpdate: change item", bestItem);
          this.currentIndex = this._items.indexOf(bestItem);
          this.notify();

          if (this.onItemChanged) {
            if (bestItem.hidden) {
              this.onItemChanged(this.visibleItemForTime(gameTime.utcSeconds - firstStart.utcSeconds));
            } else {
              this.onItemChanged(bestItem);
            }
          }

          return;
        }
      }
    }
  }, {
    key: "updateFluidSource",
    value: function updateFluidSource() {
      var changed = false;
      var src = null;

      var momentTime = _Time.Time.fromMoment(this.currentMoment);

      if (this.currentMoment) {
        var _iterator7 = _createForOfIteratorHelper(this._fluidSources),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var fs = _step7.value;
            var cam = (0, _getProperty.getProperty)("meta.camera.name", fs, "");

            if (cam === "tracecam") {
              var fsRange = _TimeRange.TimeRange.fromMoment(fs);

              if (fsRange.contains(momentTime)) {
                src = fs;
                break;
              }
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }

      console.log("PlaylistController.updateFluidSource: src", src); // assumes fluid sources are moment shaped

      if (src) {
        var srcId = (0, _getProperty.getProperty)("game_clip_id", src, null);
        var fldId = (0, _getProperty.getProperty)("game_clip_id", this._fluidSource, null);

        if (srcId !== fldId) {
          console.log("PlaylistController.updateFluidSource: change from", this._fluidSource, "to", src);
          changed = true;
          this._fluidSource = src;
          this.notify();
          this._waitingForFluidSourceUpdate = this._fluidSource;
        }
      } else {
        console.warn("PlaylistController.updateFluidSource: no fluid source", this.currentItem, this._fluidSources);
      }

      return changed;
    } // called from video player to coninue fluid source updating process

  }, {
    key: "onCurrentMomentChanged",
    value: function onCurrentMomentChanged(item) {
      if (!item) {
        return;
      }

      var moment;

      if (item.moment) {
        moment = item.moment;
      } else {
        moment = item;
      }

      console.log("PlaylistController.onCurrentMomentChanged", moment, this._waitingForFluidSourceUpdate, this._waitingToJumpTo);

      if (this._waitingForFluidSourceUpdate) {
        if (this._fluidSource.game_clip_id === moment.game_clip_id) {
          this._waitingForFluidSourceUpdate = null; // for now force default to tracecam

          this.camera = "tracecam";
          console.log("PlaylistController updating video controller with new fluid source", this._fluidSource, this._cameras);

          if (this._waitingToJumpTo) {
            var firstRawVideo = this.firstMainFluidSource();

            var firstStart = _Time.Time.fromMoment(firstRawVideo).utcSeconds;

            var fluidStart = _Time.Time.fromMoment(this._fluidSource).utcSeconds;

            var time = this._waitingToJumpTo - (fluidStart - firstStart);
            this._videoController.startAt = time;
          }

          this._videoController.defaultCamera = this.camera;

          this._videoController.update(this._fluidSource, "video-player-".concat(this.id), this._cameras, this._defaultCamera);
        }
      } else if (this._waitingForNonFluidSourceUpdate) {
        console.log("PlaylistController.onCurrentMomentChanged: non-fluid", this.currentMoment.game_clip_id, moment.game_clip_id);

        if (this.currentMoment.game_clip_id === moment.game_clip_id) {
          this._waitingForNonFluidSourceUpdate = null;
          console.log("PlaylistController updating video controller with new non-fluid source", this.currentMoment, this._cameras);

          this._videoController.update(this.currentMoment, "video-player-".concat(this.id), this._cameras, this._defaultCamera);
        }
      }
    } // message the ui that the playlist controller has changed

  }, {
    key: "notify",
    value: function notify() {
      var _this2 = this;

      setTimeout(function () {
        console.log("PlaylistController.notify");
        document.dispatchEvent(new CustomEvent("trc-playlist-changed-".concat(_this2.id)));
      }, 50);
    }
    /**
     * Find the best item for a given time
     *
     * @param {*} time - game time in seconds
     * @returns {*} - item
     * @memberof PlaylistController
     */

  }, {
    key: "itemForTime",
    value: function itemForTime(time) {
      var gameTime = _Time.Time.fromSeconds(time, this.firstMainFluidSource().start_time);

      var bestItem = null;
      var sortedItems = this.sortedItems();
      var nowItems = [];

      var _iterator8 = _createForOfIteratorHelper(sortedItems),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _item = _step8.value;

          var momentTimeRange = _TimeRange.TimeRange.fromMoment(_item);

          momentTimeRange.fuzz = 16;

          if (momentTimeRange.contains(gameTime) && !_item.hidden) {
            nowItems.push(_item);
          }
        } // filter items to the ones in the same source

      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      var fluidSourceForTime = null;

      var _iterator9 = _createForOfIteratorHelper(this.mainFluidSources()),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var src = _step9.value;

          var srcTimeRange = _TimeRange.TimeRange.fromMoment(src);

          srcTimeRange.fuzz = 16;

          if (srcTimeRange.contains(gameTime)) {
            fluidSourceForTime = src;
            break;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      if (fluidSourceForTime) {
        var fluidSourceRange = _TimeRange.TimeRange.fromMoment(fluidSourceForTime);

        sortedItems = sortedItems.filter(function (item) {
          var itemTime = _Time.Time.fromMoment(item);

          return fluidSourceRange.contains(itemTime);
        });
      } // if possible filter out hidden items


      if (sortedItems.length > 1) {
        sortedItems = sortedItems.filter(function (item) {
          return !item.hidden;
        });
      }

      if (nowItems.indexOf(this.currentItem) >= 0) {
        // current item is still valid
        bestItem = this.currentItem;
      } else if (nowItems.length >= 1) {
        bestItem = nowItems[0];
      } else {
        // find closest items before the gameTime default to first
        bestItem = sortedItems[0];

        var bestDistance = gameTime.utc - _Time.Time.fromMoment(bestItem).utc;

        var _iterator10 = _createForOfIteratorHelper(sortedItems),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var item = _step10.value;

            var itemTime = _Time.Time.fromMoment(item);

            var diff = gameTime.utc - itemTime.utc;

            if (diff < 0) {
              break;
            }

            if (diff < bestDistance) {
              bestItem = item;
              bestDistance = diff;
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }

      return bestItem;
    }
    /**
     * Find the best visible item
     *
     * @param {*} time - game time in seconds
     * @returns {*} - item
     * @memberof PlaylistController
     */

  }, {
    key: "visibleItemForTime",
    value: function visibleItemForTime(time) {
      var gameTime = _Time.Time.fromSeconds(time, this.firstMainFluidSource().start_time);

      var bestItem = null;
      var sortedItems = this.sortedVisibleItems();
      var nowItems = [];

      var _iterator11 = _createForOfIteratorHelper(sortedItems),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _item2 = _step11.value;

          var momentTimeRange = _TimeRange.TimeRange.fromMoment(_item2);

          momentTimeRange.fuzz = 16;

          if (momentTimeRange.contains(gameTime)) {
            nowItems.push(_item2);
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      if (nowItems.indexOf(this.currentItem) >= 0) {
        // current item is still valid
        bestItem = this.currentItem;
      } else if (nowItems.length >= 1) {
        bestItem = nowItems[0];
      } else {
        // find closest items before the gameTime default to first
        bestItem = sortedItems[0];

        var bestDistance = gameTime.utc - _Time.Time.fromMoment(bestItem).utc;

        var _iterator12 = _createForOfIteratorHelper(sortedItems),
            _step12;

        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var item = _step12.value;

            var itemTime = _Time.Time.fromMoment(item);

            var diff = gameTime.utc - itemTime.utc;

            if (diff < 0) {
              break;
            }

            if (diff < bestDistance) {
              bestItem = item;
              bestDistance = diff;
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }

      return bestItem;
    }
    /*
     * Playlist controls
     */

  }, {
    key: "goToItem",
    value: function goToItem(id) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var val = false;
      var matchedIndex = null;

      var _iterator13 = _createForOfIteratorHelper(this.items.entries()),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _step13$value = _slicedToArray(_step13.value, 2),
              index = _step13$value[0],
              item = _step13$value[1];

          if ( // eslint-disable-next-line eqeqeq
          item.user_playlist_clip_id == id || // eslint-disable-next-line eqeqeq
          item.game_clip_id == id) {
            if (this.currentIndex === index) {
              val = false;
            } else {
              //this.currentIndex = index
              matchedIndex = index;
              val = true;
            }

            break;
          }

          if (item.moment) {
            var m = item.moment; // eslint-disable-next-line eqeqeq

            if (m.game_clip_id == id) {
              // eslint-disable-next-line eqeqeq
              if (this.currentIndex == index) {
                val = false;
              } else {
                //this.currentIndex = index
                matchedIndex = index;
                val = true;
              }

              break;
            }
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      if (this._waitingToJumpTo || this._waitingToJumpToLocal) {
        // prevent DJ skip effect
        // not the best solution but works ok
        // downside it prevents rapid clicking on the timeline
        console.log("PlaylistController.goToItem waiting to jump to abort", this._waitingToJumpTo, this._waitingToJumpToLocal);
        return;
      }

      console.log("PlaylistController.goToItem", "MI", matchedIndex, "val", val, "lastIndex", this.lastIndex);

      if (this._currentIndex === matchedIndex) {
        console.log("PlaylistController.goToItem ignoring going anywhere");
        return;
      } // if not fluild stop here, notify and call onItemChanged


      if (!this.fluid) {
        if (val) {
          this.currentIndex = matchedIndex;
          this._waitingForNonFluidSourceUpdate = true;
          console.log("PlaylistController.goToItem not fluid goto gone to");
          this.notify();

          if (this.onItemChanged) {
            console.log("PlaylistController.goToItem not fluid goto cb", this.currentItem);
            this.onItemChanged(this.currentItem);
          }
        }

        console.log("PlaylistController.goToItem not fluid goto return"); // end none fluid logic here

        return;
      }

      if (val === true) {
        console.log("PlaylistController.goToItem going to index ", matchedIndex, _objectSpread({}, this));
        this.currentIndex = matchedIndex;
        this.updateFluidSource();
      }

      console.log("PlaylistController.goToItem of val or force", val, force, this.fluid);

      if ((val || force) && this.fluid) {
        // jump to time of moment
        var moment = this.currentMoment;
        console.log("PlaylistController.goToItem of val or force moment", moment);

        if (moment) {
          console.log("PlaylistController.goToItem moment", moment);
          console.log("PlaylistController.goToItem fluidSource", this._fluidSource);

          var momentStart = _Time.Time.fromMoment(moment);

          var fluidRange = _TimeRange.TimeRange.fromMoment(this._fluidSource);

          console.log("PlaylistController.goToItem jumping to time");

          if (fluidRange.contains(momentStart)) {
            var t = momentStart.utcSeconds - fluidRange._start.utcSeconds;
            console.log("PlaylistController.goToItem jumping to ", t);

            this._videoController.jump(t);

            this.notify();

            if (this.onItemChanged) {
              console.log("PlaylistController.goToItem calling onItemChanged", moment);
              this.onItemChanged(this.currentItem);
            }
          }
        }
      }

      return val;
    }
  }, {
    key: "goToNext",
    value: function goToNext() {
      if (!this.fluid) {
        var item = this.nextItem;
        var nextIndex = this.items.indexOf(item);
        this._currentIndex = nextIndex;
        this._waitingForNonFluidSourceUpdate = true;
        this.notify();

        if (this.onItemChanged) {
          console.log("PlaylistController.goToNext calling onItemChanged", item);
          this.onItemChanged(item);
        }

        return;
      }

      if (this._videoController.controllingSource) {
        var gameTime = _Time.Time.fromSeconds((0, _getProperty.getProperty)("_videoController.controllingSource.video.currentTime", this, 0), (0, _getProperty.getProperty)("_videoController.controllingSource.moment.start_time", this, 0));

        var sortedVisibles = this.sortedVisibleItems();

        if (sortedVisibles.length === 0) {
          console.warn("PlaylistController.goToNext no visible items");
          return;
        }

        var nextMoment = sortedVisibles[0];

        var _iterator14 = _createForOfIteratorHelper(sortedVisibles),
            _step14;

        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var _item4 = _step14.value;

            if (_item4.start_time > gameTime.utc && _item4 !== this.currentItem) {
              nextMoment = _item4;
              break;
            }
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }

        var _item3 = nextMoment;

        var _nextIndex = this.items.indexOf(_item3);

        console.log("PlaylistController.goToNext", _item3, _nextIndex, this);

        if (this.fluid) {
          // jump to time of moment
          if (_item3) {
            var firstStart = _Time.Time.fromMoment(this.firstMainFluidSource());

            var momentStart = _Time.Time.fromMoment(_item3);

            var t = momentStart.utcSeconds - firstStart.utcSeconds;
            console.log("PlaylistController.goToNext jumping to ", t, this.currentMoment, this.firstMainFluidSource);
            this.jump(t);
          }
        } else {
          this.currentIndex = _nextIndex;
          this.notify();

          if (this.onItemChanged) {
            console.log("PlaylistController.goToNext calling onItemChanged", _item3);
            this.onItemChanged(_item3);
          }
        }
      }
    }
  }, {
    key: "goToPrev",
    value: function goToPrev() {
      if (!this.fluid) {
        var item = this.prevItem;
        var prevIndex = this.items.indexOf(item);
        this._currentIndex = prevIndex;
        this._waitingForNonFluidSourceUpdate = true;
        this.notify();

        if (this.onItemChanged) {
          console.log("PlaylistController.goToNext calling onItemChanged", item);
          this.onItemChanged(item);
        }

        return;
      }

      var utcTime = _Time.Time.fromSeconds(this._videoController.controllingSource.video.currentTime, (0, _getProperty.getProperty)("_videoController.controllingSource.moment.start_time", this, 0)).utc;

      var reversedItems = this.sortedVisibleItems().slice().reverse();
      var previousMoment = reversedItems[0];

      if (Math.abs(this.currentMoment.start_time - utcTime) > 3000) {
        console.log("PlaylistController.goToPrev using current moment", Math.abs(this.currentMoment.start_time - utcTime));
        previousMoment = this.currentMoment;
      } else {
        utcTime = this.currentMoment.start_time;

        var _iterator15 = _createForOfIteratorHelper(reversedItems),
            _step15;

        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var _item5 = _step15.value;

            if (_item5.start_time < utcTime && _item5 !== this.currentItem) {
              previousMoment = _item5;
              break;
            }
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }

        console.log("PlaylistController.goToPrev using prev moment");
      }

      console.log("PlaylistController.goToPrev", previousMoment, utcTime);

      if (this.fluid) {
        // jump to time of moment
        var first = this.firstMainFluidSource();

        if (previousMoment && first) {
          var momentStart = _Time.Time.fromMoment(previousMoment);

          var firstStart = _Time.Time.fromMoment(first);

          var time = momentStart.utcSeconds - firstStart.utcSeconds;
          console.log("PlaylistController.goToPrev jumping to ", time, previousMoment);
          this.jump(time);
        }
      } else {
        var _prevIndex = this.items.indexOf(previousMoment);

        this.currentIndex = _prevIndex;
        this.notify();

        if (this.onItemChanged) {
          console.log("PlaylistController.goToPrev calling onItemChanged", previousMoment);
          this.onItemChanged(previousMoment);
        }
      }
    }
  }, {
    key: "goToNextTouch",
    value: function goToNextTouch(t) {
      if (!this.fluid) {
        return;
      }

      var touches = this.touches;
      var currentTouches = [];

      var _iterator16 = _createForOfIteratorHelper(touches),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var touch = _step16.value;

          if ((touch - this._fluidSource.start_time) / 1000 > t) {
            currentTouches.push((touch - this._fluidSource.start_time) / 1000);
          }
        } // eslint-disable-next-line eqeqeq

      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }

      if (currentTouches.length == 0) {
        this._videoController.jump(touches[0]);
      } else {
        this._videoController.jump(currentTouches[0]);
      }
    }
  }, {
    key: "jumpAhead",
    value: function jumpAhead(amt) {
      if (!this.fluid) {
        this._videoController.jumpForward(amt);
      } else {
        var to = this.fluidCurrentTime(this._videoController.controllingSource.video.currentTime, this.activeFluidSource());
        to += amt;
        this.jump(to);
      }
    }
  }, {
    key: "jumpBack",
    value: function jumpBack(amt) {
      if (!this.fluid) {
        this._videoController.jumpBackward(amt);
      } else {
        var to = this.fluidCurrentTime(this._videoController.controllingSource.video.currentTime, this.activeFluidSource());
        to -= amt;
        this.jump(to);
      }
    }
  }, {
    key: "jump",
    value: function jump(to) {
      if (!this.fluid) {
        this._videoController.jump(to);

        return;
      }

      if (this._waitingToJumpTo) {
        console.log("PlaylistController.jump ignoring jump already jumping");
        return;
      }

      if (this._waitingToJumpToLocal) {
        console.log("PlaylistController.jump ignoring jump already jumping LOCAL");
        return;
      }

      console.log("PlaylistController.jump", to); // does this time exists in the current fluid source?

      var firstRawVideo = this.firstMainFluidSource();

      var firstStart = _Time.Time.fromMoment(firstRawVideo);

      var toTime = _Time.Time.fromSeconds(to, firstRawVideo.start_time);

      var activeRange = _TimeRange.TimeRange.fromMoment(this.activeFluidSource());

      var fluidRange = _TimeRange.TimeRange.fromMoment(this._fluidSource);

      if (activeRange.contains(toTime)) {
        // jump to a time in the same raw video
        var t = to - (activeRange.start.utcSeconds - firstStart.utcSeconds);
        console.log("PlaylistController.jump activeSource LOCAL to,t", to, t, this._fluidSource, this.camera);

        if (this._waitingForFluidSourceUpdate) {
          console.log("PlaylistController.jump waiting for LOCAL", this);
          this._waitingToJumpTo = to;
        } else {
          console.log("PlaylistController.jump no wait for LOCAL", this);
          this._waitingToJumpToLocal = to;

          this._videoController.jump(t);
        }
      } else if (fluidRange.contains(toTime)) {
        // jump to a time in the same raw video
        var _t = to - (fluidRange.start.utcSeconds - firstStart.utcSeconds);

        console.log("PlaylistController.jump fluidSource LOCAL to,t", to, _t, this._fluidSource, this.camera);
        var activeCamera = this.cameraForMoment(this.activeFluidSource());
        var fluidCamera = this.cameraForMoment(this._fluidSource);

        if (fluidCamera.name !== activeCamera.name) {
          console.log("PlaylistController.jump camera LOCAL", fluidCamera.name, to);

          this._videoController.selectCamera(fluidCamera.name, toTime.utcSeconds);
        } else if (this._waitingForFluidSourceUpdate) {
          console.log("PlaylistController.jump waiting for LOCAL", this);
          this._waitingToJumpTo = to;
        } else {
          console.log("PlaylistController.jump no wait for LOCAL", this);
          this._waitingToJumpToLocal = to;

          this._videoController.jump(_t);
        }
      } // does this time exist in any fluid source?
      else {
        var isToTimeInAnyFluidSource = false;

        var _iterator17 = _createForOfIteratorHelper(this.mainFluidSources()),
            _step17;

        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var _src = _step17.value;

            var _range = _TimeRange.TimeRange.fromMoment(_src);

            if (_range.contains(toTime)) {
              isToTimeInAnyFluidSource = true;
              break;
            }
          } // time is not in a fluid source,
          // so we need to find the closest
          // fluid source in the future

        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }

        if (!isToTimeInAnyFluidSource) {
          var closestFluidSource = null;

          var _iterator18 = _createForOfIteratorHelper(this.mainFluidSources()),
              _step18;

          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var src = _step18.value;

              var range = _TimeRange.TimeRange.fromMoment(src);

              if (range.start.utcSeconds > toTime.utcSeconds) {
                closestFluidSource = range;
                break;
              }
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }

          if (closestFluidSource) {
            toTime = closestFluidSource.start;
            toTime.addSeconds(3);
            console.warn("PlaylistController.jump to time adjusted to closets fluid source: toTime", toTime.utcSeconds, closestFluidSource);
          } else {
            console.warn("PlaylistController.jump no fluid source found");
            return;
          }
        }

        var gameTimeInSeconds = toTime.utcSeconds - firstStart.utcSeconds;
        console.log("PlaylistController.jump to game time", gameTimeInSeconds, "s");
        this._gotoDebounce = this.currentMoment.game_clip_id;
        var jumpItem = this.itemForTime(gameTimeInSeconds);

        if (jumpItem) {
          // jump to a time in a different raw video
          var index = this.items.indexOf(jumpItem);
          this.currentIndex = index;
          this._waitingToJumpTo = gameTimeInSeconds;
          console.log("PlaylistController.jump FLUID index", index, gameTimeInSeconds);
          this.updateFluidSource();
          this.notify();

          if (this.onItemChanged) {
            console.log("PlaylistController.jump onItemChanged", this.currentMoment);
            this.onItemChanged(this.currentMoment);
          }
        }
      }
    }
  }, {
    key: "getTouchesFromMoments",
    value: function getTouchesFromMoments(moments) {
      var change = false;
      var allTouches = [];

      var _iterator19 = _createForOfIteratorHelper(moments),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var moment = _step19.value;
          allTouches.push.apply(allTouches, _toConsumableArray(moment.touch_times));
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }

      this.touches = _toConsumableArray(new Set(allTouches.sort())); //console.log("PlaylistController allTouches", this.touches)

      return change;
    }
  }, {
    key: "cameraForMoment",
    value: function cameraForMoment(moment) {
      var camera = null;

      if (moment && moment.camera) {
        camera = moment.camera;
      } else if (moment && moment.meta) {
        camera = moment.meta.camera;
      }

      return camera;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var playlistController = this._instances.find(function (item) {
        return item.id === id;
      });

      if (!playlistController) {
        playlistController = new PlaylistController({
          id: id
        });

        var videoController = _VideoController.VideoController.getInstance(id);

        videoController._playlistController = playlistController;
        playlistController._videoController = videoController;

        this._instances.push(playlistController);
      }

      return playlistController;
    }
  }, {
    key: "findInstance",
    value: function findInstance() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var controller = this._instances.find(function (item) {
        return item.id === id;
      });

      if (!controller) {
        controller = null;
      }

      return controller;
    }
  }]);

  return PlaylistController;
}();

exports.PlaylistController = PlaylistController;

_defineProperty(PlaylistController, "_instances", []);